module.exports = __webpack_public_path__ + "img/topicFood.6f2824d4.png";